import { Link } from "react-router-dom";
import { Mail, MapPin, Phone } from "lucide-react";
import { useLang, WHATSAPP_URL } from "@/i18n";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer data-testid="site-footer" className="bg-lake-deep border-t hairline-light text-glacier">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <div className="flex items-center gap-2.5">
            <img src="/guidone.png" alt="Guidone Circolo Vela Manerba del Garda" className="h-10 w-auto" data-testid="footer-logo-img" />
            <span className="font-serif text-xl">Circolo Vela Manerba</span>
          </div>
          <p className="mt-4 text-glacier/60 text-sm leading-relaxed max-w-xs">{t.footer.tagline}</p>
          <p className="mt-4 font-mono text-[11px] text-glacier/40">{t.footer.medical}</p>
        </div>
        <div>
          <h4 className="font-mono text-xs uppercase tracking-[0.25em] text-gold">{t.footer.contacts}</h4>
          <ul className="mt-5 space-y-3 text-sm text-glacier/70">
            <li>
              <a
                data-testid="footer-address-link"
                href="https://maps.google.com/?q=Via+del+Zocco+110,+25080+Manerba+del+Garda+BS"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-start gap-2.5 hover:text-gold transition-colors"
              >
                <MapPin className="w-4 h-4 mt-0.5 text-teal-light shrink-0" />
                {t.footer.where}
              </a>
            </li>
            <li>
              <a
                data-testid="footer-whatsapp-link"
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2.5 hover:text-gold transition-colors"
              >
                <Phone className="w-4 h-4 text-teal-light" />
                WhatsApp: +39 338 1178 389
              </a>
            </li>
            <li>
              <a
                data-testid="footer-whatsapp2-link"
                href="https://wa.me/393793938301?text=Ciao%2C%20vorrei%20informazioni%20sui%20corsi%20e%20tour%20a%20Manerba%20del%20Garda"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2.5 hover:text-gold transition-colors"
              >
                <Phone className="w-4 h-4 text-teal-light" />
                WhatsApp: +39 379 393 8301
              </a>
            </li>
            <li>
              <a
                data-testid="footer-email-link"
                href="mailto:circolovelamanerba@gmail.com"
                className="flex items-center gap-2.5 hover:text-gold transition-colors"
              >
                <Mail className="w-4 h-4 text-teal-light" />
                circolovelamanerba@gmail.com
              </a>
            </li>
          </ul>
        </div>
        <div className="flex flex-col md:items-end justify-between gap-6">
          <Link
            data-testid="footer-booking-cta"
            to="/prenota"
            className="bg-gold text-lake-deep font-semibold px-7 py-3.5 rounded-full text-sm hover:bg-glacier transition-colors w-fit"
          >
            {t.nav.book}
          </Link>
          <p className="font-mono text-[11px] text-glacier/35">© 2026 {t.footer.rights}</p>
          <p className="font-mono text-[10px] text-glacier/25 mt-1">Meteo: Open-Meteo.com</p>
        </div>
      </div>
    </footer>
  );
}
